package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiDeleteNoBody
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPostMultipart
import com.arena_web.data.http.apiPut
import io.ktor.client.*
import io.ktor.http.HttpStatusCode

class UserApi(private val client: HttpClient) {

    // ── Current user ──
    suspend fun getMe(): ApiResponse<UserDto> {
        return client.apiGet("v1/users/me")
    }

    suspend fun updateMe(request: UpdateUserRequest): ApiResponse<UserDto> {
        return client.apiPut("v1/users/me", request)
    }

    suspend fun uploadMyAvatar(
        fileBytes: ByteArray,
        fileName: String,
        contentType: String,
    ): ApiResponse<UserDto> {
        return client.apiPostMultipart("v1/users/me/avatar", fileBytes, fileName, contentType)
    }

    suspend fun updateActiveRole(request: UpdateActiveRoleRequest): ApiResponse<UserDto> {
        return client.apiPut("v1/users/me/active-role", request)
    }

    suspend fun deleteMe(): HttpStatusCode {
        return client.apiDeleteNoBody("v1/users/me")
    }

    // ── Current user sport profile ──
    suspend fun getMySportProfile(sportId: String): ApiResponse<SportProfileDto> {
        return client.apiGet("v1/users/me/sport-profile", mapOf("sportId" to sportId))
    }

    suspend fun updateMySportProfile(
        sportId: String,
        request: UpdateSportProfileRequest,
    ): ApiResponse<SportProfileDto> {
        return client.apiPut("v1/users/me/sport-profile?sportId=$sportId", request)
    }

    suspend fun getMyStatsChart(params: Map<String, String>): ApiResponse<StatsChartDto> {
        return client.apiGet("v1/users/me/sport-profile/chart", params)
    }

    suspend fun getMySportProfileAggregate(): ApiResponse<SportProfileAggregateDto> {
        return client.apiGet("v1/users/me/sport-profile/aggregate")
    }

    suspend fun getMyAwards(): ApiResponse<List<UserAwardDto>> {
        return client.apiGet("v1/users/me/awards")
    }

    // ── Public user endpoints ──
    suspend fun getUser(userId: String): ApiResponse<UserDto> {
        return client.apiGet("v1/users/$userId")
    }

    suspend fun getSportProfile(userId: String, params: Map<String, String> = emptyMap()): ApiResponse<SportProfileDto> {
        return client.apiGet("v1/users/$userId/sport-profile", params)
    }

    suspend fun getSportProfileAggregate(userId: String): ApiResponse<SportProfileAggregateDto> {
        return client.apiGet("v1/users/$userId/sport-profile/aggregate")
    }

    suspend fun getUserStatsChart(userId: String, params: Map<String, String>): ApiResponse<StatsChartDto> {
        return client.apiGet("v1/users/$userId/sport-profile/chart", params)
    }

    suspend fun getUserTeams(userId: String): ApiResponse<List<TeamDto>> {
        return client.apiGet("v1/users/$userId/teams")
    }

    suspend fun getUserFavoriteMedia(userId: String): ApiResponse<List<EventMediaDto>> {
        return client.apiGet("v1/users/$userId/favorite-media")
    }

    suspend fun getUserPosts(userId: String, params: Map<String, String> = emptyMap()): ApiResponse<UserPostPageDto> {
        return client.apiGet("v1/users/$userId/posts", params)
    }

    suspend fun getUserAwards(userId: String): ApiResponse<List<UserAwardDto>> {
        return client.apiGet("v1/users/$userId/awards")
    }
}
